// extracted by mini-css-extract-plugin
export default {"cardsContainer":"modelsGrid_cardsContainer__2Yboz"};